/**
 * Framer Motion versions of the CSS easing curves in `styles/global.css`
 * (`--ease-soft`, `--ease-out-expo`, `--ease-bounce`, `--ease-drop`). Framer
 * Motion can't read CSS custom properties for its own `ease` option, so
 * `motion/react` call sites need the numbers duplicated — import these
 * instead of re-typing the cubic-bezier arrays (or reaching for a generic
 * `'easeInOut'`) so the two systems stay visually matched.
 */
export const EASE_SOFT = [0.22, 1, 0.36, 1] as const;
export const EASE_OUT_EXPO = [0.16, 1, 0.3, 1] as const;
export const EASE_BOUNCE = [0.34, 1.4, 0.5, 1] as const;
export const EASE_DROP = [0.4, 1.3, 0.4, 1] as const;

/** The app's standard spring feel for shared-layout transitions (sliding tab
 * pills, drag-to-reorder, etc.) — snappy but not twitchy. */
export const SPRING_SNAPPY = { type: 'spring', stiffness: 400, damping: 30 } as const;
